import Details from "@/components/history/Details";
import Header from "@/components/shared/Header";
import { assigned_kdes } from "@/constants/dummy";
import { useFormik, FormikProvider } from "formik";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import renderFormInput from "../../../components/shared/renderFormInput";

export default function TrackingForms() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const isUpdate = state?.isUpdate ?? false;

  const [saveLoading, setSaveLoading] = React.useState<boolean>(false);

  // fetch current cte on the some contions
  const current_cte = state?.cte?.name || state?.cte || null;
  // fetch assigned kdes to the cte above, for now i am using a dummy data
  const kdes = assigned_kdes || null;

  /*
    Constructs initial values object from the kdes array
  */
  const kdesObject = React.useMemo(() => {
    if (kdes) {
      const obj: any = {};
      kdes.forEach((item: any) => {
        obj[item.name] = item.value;
      });
      return obj;
    }
    return {};
  }, [kdes]);

  /*
    Constructs validation schema object from the kdes array
  */
  const validationObject = React.useMemo(() => {
    if (kdes) {
      const obj: any = {};
      kdes.forEach((item: any) => {
        if (item.isRequired) {
          obj[item.name] = Yup.string().required(`${item.label} is required`);
        }
      });
      return Yup.object().shape(obj);
    }
    return {};
  }, [kdes]);

  const formik = useFormik({
    initialValues: kdesObject,
    validationSchema: validationObject,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const { handleSubmit, values, errors } = formik;

  return (
    <div>
      <Header
        onBack={() => navigate(-1)}
        title="Tracking Form"
        extraAction="Save"
        extraActionIcon="pi pi-save"
        onExtraAction={() => handleSubmit()}
        extraActionLoading={saveLoading}
      />
      <div className="flex flex-column align-items-center my-3 ">
        <section className={`w-11 lg:w-8`}>
          <Details
            item={{
              batch_number: "Batach#12345679",
              status: "Created",
              product: "Cocoa",
              flow: "Cocoa Flow",
            }}
          />
        </section>

        <p className="my-0 text-2xl border-bottom-1 border-gray-400 p-3 ">
          {isUpdate
            ? `Edit ${current_cte} Form`.toUpperCase()
            : `${current_cte} Form`.toUpperCase()}
        </p>

        <FormikProvider value={formik}>
          <div className="flex flex-column  gap-3 my-5 w-11 lg:w-8 ">
            {kdes?.map((item: any, index: number) => {
              return (
                <div key={index}>
                  {renderFormInput({
                    type: item.type,
                    id: item.name,
                    label: item.label,
                    isRequired: item.isRequired,
                    placeholder: item.placeholder,
                    options: item.options,
                    helperText: item.helperText,
                    value: item.values,
                  })}
                </div>
              );
            })}
          </div>
        </FormikProvider>
      </div>
    </div>
  );
}
